module.exports = __webpack_public_path__ + "media/hyper/images/payments/btc-f4c82d5ee9effeebf1cdf0454601ac1f.png";